import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { IConfirmDialogOptions } from 'src/app/core/interfaces/modal.interface'


@Component({
  selector: 'admin-confirm-dialog-component',
  template: `
    @if (data.title) {
      <div mat-dialog-title class="dialog__title">{{data.title}}</div>
    }
    @if (data.content) {
      <mat-dialog-content class="dialog__content">
        {{data.content}}
      </mat-dialog-content>
    }
    <mat-dialog-actions class="dialog__actions">
      @if (data.cancelLabel) {
        <button [matButton]="'outlined'" mat-dialog-close [mat-dialog-close]="'cancel'">{{data.cancelLabel}}</button>
      }
      <button [matButton]="'elevated'" mat-dialog-close [mat-dialog-close]="'confirm'">{{data.confirmLabel}}</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['../../../../assets/admin.scss'],
  styles: [`
    :host {
      display: block;
    }
  `],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
  ],
})
export class AdminConfirmDialogComponent {
  data = inject<IConfirmDialogOptions>(MAT_DIALOG_DATA)
}
